import { LoadingOutlined } from '@ant-design/icons';
import { Alert, Button, Input, Tag } from 'antd';
import React from 'react';
import { UNIT_CODE_LENGTH } from './constants';
import { isCompleteUnitCode, normalizeUnitCode } from './utils';

const UnitCodeInput = ({
  value,
  onChange,
  onSubmit,
  loading,
  error,
  hint,
  showContinue,
  suggestions = [],
  disabled,
}) => {
  const handleChange = (event) => {
    const code = normalizeUnitCode(event?.target?.value);
    onChange(code);
    if (isCompleteUnitCode(code)) {
      onSubmit(code);
    }
  };

  const handleSuggestionClick = (code) => {
    if (disabled || loading) return;
    const normalized = normalizeUnitCode(code);
    onChange(normalized);
    onSubmit(normalized);
  };

  return (
    <div className="unit-scan-code">
      <div className="unit-scan-label">
        Enter the {UNIT_CODE_LENGTH} character code printed under the QR on the
        unit label
      </div>
      {hint && <div className="unit-scan-label">{hint}</div>}
      <div className="unit-scan-code-row">
        <Input
          autoFocus
          allowClear
          size="large"
          className="unit-scan-code-input"
          placeholder="e.g. 1978001001"
          value={value}
          maxLength={UNIT_CODE_LENGTH}
          disabled={disabled || loading}
          onChange={handleChange}
          onPressEnter={() => value?.trim() && onSubmit(value)}
          status={error ? 'error' : undefined}
          suffix={loading ? <LoadingOutlined /> : <span />}
        />
        {showContinue && (
          <Button
            type="primary"
            size="large"
            className="common-button"
            loading={loading}
            disabled={disabled || !value?.trim()}
            onClick={() => onSubmit(value)}
          >
            Continue
          </Button>
        )}
      </div>
      {loading && (
        <div className="unit-scan-label mt-8">Checking this unit…</div>
      )}
      {error && (
        <Alert className="mt-8" type="error" showIcon message={error} />
      )}
      {suggestions?.length > 0 && (
        <div className="unit-scan-suggestions">
          <div className="unit-scan-label">Units ready to pick</div>
          <div>
            {suggestions?.map((code) => (
              <Tag
                key={code}
                className="pointer"
                onClick={() => handleSuggestionClick(code)}
              >
                {code}
              </Tag>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default UnitCodeInput;
